import { useAuthStore } from '~/modules/auth/stores/auth.store';
import { useCurrentEmployeeStore } from '~/modules/employees/stores/current-employee.store';
import { useDictionariesStore } from '~/modules/dictionaries/stores/dictionaries.store';

// Инициализация глобальных сторов при старте приложения.
// Порядок важен: профиль сотрудника — проба сессии, от её исхода зависят
// остальные авторизованные запросы.
export default defineNuxtPlugin({
  name: 'init-stores',
  parallel: false,
  async setup() {
    useAuthStore();

    await useCurrentEmployeeStore().initStore();
    await useDictionariesStore().initStore();
  },
});
